import React from 'react'
import { Text } from 'components/atoms'
import { generateEditorPath } from 'services/generators'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import ErrorBoundary from './ErrorBoundary'

const ErrorBoundaryEditor = ({ children, pageId, subweb }) => (
  <ErrorBoundary
    message="Erro a pré-visualizar página"
    helper={(
      <Text modifiers={[]}>
        Desfaça as suas alterações ou vá ao
        {' '}
        <Link to={generateEditorPath({ pageId, subweb, next: '/history' })}>
        histórico
        </Link>
        {' '}
        e restaure uma versão anterior.
      </Text>
    )}
  >
    {children}
  </ErrorBoundary>
)

ErrorBoundaryEditor.propTypes = {
  children: PropTypes.node.isRequired,
  subweb: PropTypes.string.isRequired,
  pageId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
}

export default ErrorBoundaryEditor
